import Autoplay from 'embla-carousel-autoplay';

import useEmblaCarousel from 'embla-carousel-react';
import { WheelGesturesPlugin } from 'embla-carousel-wheel-gestures';
import { useDotButton } from '@/lib/hooks/use-embla-dots.ts';

type Props = {
	photos: Array<{
		id: number;
		url: string;
		textOrNull: string;
		priority: number;
	}>;
};

export default function HeroCarousel({ photos = [] }: Props) {
	const [emblaRef, emblaApi] = useEmblaCarousel(
		{
			loop: true,
			containScroll: false,
		},
		[Autoplay({ playOnInit: true, delay: 5000 }), WheelGesturesPlugin({ forceWheelAxis: 'x' })],
	);

	const { scrollSnaps, selectedIndex, onDotButtonClick } = useDotButton(emblaApi);

	return (
		<div className="w-full h-full flex flex-col">
			<div className="embla w-[95%] ml-auto max-lg:ml-0 max-lg:w-full max-md:w-full aspect-[16/9] rounded-xl overflow-hidden">
				<div className="embla__viewport w-full h-full pl-8 max-xl:pl-6 max-md:pl-2" ref={emblaRef}>
					<div className="embla__container h-full">
						{photos
							?.sort((a, b) => a?.priority - b?.priority)
							?.map((item, index) => (
								<div
									key={index}
									className="embla__slide aspect-[16/9] flex-1 [--slide-size-lg:100%] [--slide-spacing-lg:0] [--slide-spacing-sm:0] [--slide-spacing:0] [--slide-height:auto] [--slide-size-sm:100%]"
								>
									<div className="w-full h-full rounded-xl relative">
										<img
											src={item.url}
											alt={item?.textOrNull}
											className="object-cover w-full h-full"
										/>

										{item?.textOrNull && (
											<div className="w-full h-full select-none flex items-end justify-start top-0 left-0 rounded-xl absolute bg-black/50 p-4">
												<h2 className="text-white text-5xl max-2xl:text-4xl max-xl:text-3xl max-lg:text-4xl max-md:text-2xl">
													{item?.textOrNull}
												</h2>
											</div>
										)}
									</div>
								</div>
							))}
					</div>
				</div>
			</div>

			<div className="w-[95%] ml-auto max-lg:ml-0 max-md:w-full mt-4 px-4 flex items-center justify-between gap-4 max-lg:hidden">
				<div className="flex items-center gap-2">
					{Array.from({ length: scrollSnaps?.length || 3 })
						.fill(null)
						?.map((_, i) => (
							<button
								key={`carousel_dot_${i}`}
								className="p-[4px] flex items-center justify-center w-[20px] h-[20px] shadow-none cursor-pointer"
								onClick={() => onDotButtonClick(i)}
							>
								<span
									className={`w-[12px] h-[12px] rounded-[100%] ${selectedIndex === i ? 'bg-[var(--primary)]' : 'bg-[var(--primary-light)]'}`}
								/>
							</button>
						))}
				</div>
			</div>
		</div>
	);
}
